<div class="competition-header container-fluid p-0 wrap pb-2 pt-2">
  <div class="row">
    <div class="col-12 col-xs-12 col-sm-12 col-md-4 col-4 back">
      <button type="button" class="btn btn-sm ml-0 pl-0" (click)="goToAdmin()">
        <span class="text-uppercase"><i class="icon icon-arrow-back-breadcrumb mr-1" aria-hidden="true"></i>Back to Manage Content</span>
      </button>
    </div>

    <div class="col-6 col-xs-6 col-sm-6 col-md-4 col-4 title text-uppercase">
      <span class="text-uppercase">Create New Competition</span>
    </div>

    <div class="col-6 col-xs-6 col-sm-6 col-md-4 col-4 pr-2 controls">
      <button type="button" class="btn discard mr-2" (click)="onDiscard()">
        <span class="text-uppercase">Discard</span>
      </button>
      <button type="button" class="btn save border-0 mr-2" (click)="onSave()">
        <span class="text-uppercase">Save new competition</span>
      </button>
    </div>
  </div>
</div>
